import React, { Fragment } from "react";

import "./Table.css";

class Table extends React.Component {
  // constructor(props) {
  //   super(props);

  // }
 

  render() {
    return (
      <div className="c-ui-table__wrapper">
        <table
          className="c-ui-table"
          data-sort-column=""
          data-sort-order="asc"
          data-search-url="/commissions/search/"
          data-auto-reload-seconds="0"
          data-new-ui="1"
          data-is-header-floating="1"
          data-has-checkboxes=""
        >
          <thead>
            <tr className="c-ui-table__row">
              <th className="c-ui-table__header c-ui-table__header--nowrap ">
                <span className="js-search-table-column">ردیف</span>
              </th>
              {" برند" === this.props.label && (
                <th className="c-ui-table__header c-ui-table__header--nowrap ">
                  <span className="table-header-searchable">
                    {"تصویر " + this.props.label}
                  </span>
                </th>
              )}
              <th className="c-ui-table__header c-ui-table__header--nowrap ">
                <span className="table-header-searchable">
                  {" نام" + this.props.label}
                </span>
              </th>
              {" گارانتی" === this.props.label && (
                <th className="c-ui-table__header c-ui-table__header--nowrap ">
                  <span className="table-header-searchable">
                    {"مدت زمان " + this.props.label}
                  </span>
                </th>
              )}
              {" برند" === this.props.label && (
                <th className="c-ui-table__header c-ui-table__header--nowrap ">
                  <span className="table-header-searchable">
                    {"نام انگلیسی " + this.props.label}
                  </span>
                </th>
              )}
              {" برند" !== this.props.label && " گارانتی" !== this.props.label && " سایز" !== this.props.label && (
              <th className="c-ui-table__header c-ui-table__header--nowrap ">
                <span className="table-header-searchable">
                  {"ویرایش " + this.props.label}
                </span>
              </th>
              )}
              <th className="c-ui-table__header c-ui-table__header--nowrap ">
                <span className="table-header-searchable">
                  {"حذف " + this.props.label}
                </span>
              </th>
            </tr>
          </thead>
          <tbody> 
            {this.props.tableData !== [] && (
              <Fragment>
                {this.props.tableData.map((data, index) => (
                  <tr>
                    <td className="c-ui-table__cell c-ui-table__cell--smaller">
                      {index + 1}
                    </td>
                    {data.enTitle && (
                      <td className="c-ui-table__cell">
                      <div className="mn-content-upload__img-container mn-content-upload__img-container-noborder">
                        <img src={'https://api.shirazpc.com/'+data.imageUrl} alt="" className="mn-content-upload__img js-upload-thumb"/>                            
                      </div>
                      </td>
                    )}
                    <td className="c-ui-table__cell">{data.title}</td>
                    {data.period && (
                      <td className="c-ui-table__cell">{data.period}</td>
                    )}
                    {data.enTitle && (
                      <td className="c-ui-table__cell">{data.enTitle}</td>
                    )}
                    {" برند" !== this.props.label && " گارانتی" !== this.props.label && " سایز" !== this.props.label && (
                    <td className="c-ui-table__cell ">
                      <span
                        className="mn-link-row__status-ui edit"
                        onClick={this.props.onEditHandler.bind(this, {
                          code: data.code,
                          label: this.props.label,
                        })}
                      >
                        {"ویرایش"}
                        <i className="fa fa-pencil-square-o" aria-hidden="true"></i>
                      </span>
                    </td>
                    )}
                    {" گارانتی" !== this.props.label && " سایز" !== this.props.label && (
                    <td className="c-ui-table__cell">
                      <span
                        className="mn-link-row__status-ui delete"
                        onClick={this.props.onDeleteHandler.bind(this, {
                          code: data.code,
                          label: this.props.label,
                        })}
                      >
                        {"حذف"}
                        <i className="fa fa-trash-o" aria-hidden="true"></i>
                      </span>
                    </td>
                    )}
                    {(" گارانتی" === this.props.label || " سایز" === this.props.label) && (
                    <td className="c-ui-table__cell">
                      <span
                        className="mn-link-row__status-ui delete"
                        onClick={this.props.onDeleteHandler.bind(this, {
                          code: data.id,
                          label: this.props.label,
                        })}
                      >
                        {"حذف"}
                        <i className="fa fa-trash-o" aria-hidden="true"></i>
                      </span>
                    </td>
                    )}
                  </tr>
                ))}
              </Fragment>
            )}
          </tbody>
        </table>
      </div>
    );
  }
}
export default Table;